module.exports = __webpack_public_path__ + "img/10_95.4aea1cc9.png";